const isNil = (x) => x == null;

export default isNil;
